import isSxSDisplayed from './isSxSDisplayed';

/**
 * This function returns true if any SxS is being displayed
 * For now it handles both legacy and refactored SxS
 */
export default function isAnySxSDisplayed(): boolean {
    return isSxSDisplayed();
}
